<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tcustbase">
      <el-form :inline="true"  :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00','23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
          </el-form-item>
        <el-form-item>
          <el-button @click="getDataList('dept')">{{ $t('query') }}</el-button>
        </el-form-item> 
      </el-form>
      <el-button class="pay_btn" type="primary" @click="payment">支付连连相关费用</el-button>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="payerName" label="付款方企业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="payeeName" label="收款方企业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountType" label="收款方账户类型" header-align="center" align="center"></el-table-column>      
        <el-table-column prop="totalAmount" label="金额" header-align="center" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="expenseType" label="费用类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="txnStatus" label="支付结果" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.txnStatus == 'TRADE_BEING_PROCESSED'">交易处理中</div>
            <div v-if="scope.row.txnStatus == 'TRADE_SUCCESS'">交易成功</div>
            <div v-if="scope.row.txnStatus == 'TRADE_FAILURE'">交易失败</div>
            <div v-if="scope.row.txnStatus == 'TRADE_CANCEL'">交易取消</div>
          </template>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" header-align="center" align="center"></el-table-column>
      
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
     
    </div>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './defrayment-add-or-update.vue'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      dataForm:{},
      mixinViewModuleOptions: {
        getDataListURL: `/api/service/charge/pageList`,
        getDataListIsPage: true,
        exportURL: '/loan/tcustbase/export',
        // /loan/tcustrelationship
        deleteURL: '/loan/tcustrelationship',
        deleteIsBatch: true,
        multilist:true,

      },

      date:'',
    }
  },
 created(){

 },

  methods:{
    
    payment(){
      this.addOrUpdateHandle()
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startDate = this.date[0]
          this.dataForm.endDate = this.date[1]
        }else{
          this.dataForm.startDate =''
          this.dataForm.endDate = ''
        }
    }
  },
  
  components: {
    AddOrUpdate
  }
}
</script>

<style lang="scss" scoped>
  .pay_btn{
    margin-bottom:30px;
  }
</style>
